var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-switch',{attrs:{"active-text":"Play Sound","inactive-text":"Mute Sound"},on:{"change":function($event){_vm.setSound(_vm.config.sound)}},model:{value:(_vm.config.sound),callback:function ($$v) {_vm.$set(_vm.config, "sound", $$v)},expression:"config.sound"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38a6d6cd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Config.vue
// module id = null
// module chunks = 